import { useEffect } from 'react';
import { Button, Loading, Tooltip } from 'react-daisyui';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { useChatContext } from '../../../../../../Chat.hook';
import { useConversationSummary } from '../../../../../../../../hooks/useConversationSummary';
import { useAnalytics } from 'src/hooks/analytics/useAnalytics.hook';
import { isSummaryEvent } from '../../../../../../ConversationSummary/ConversationSummary.functions';

export default function ConversationSummaryAction(props: { tooltipMessage: string }) {
  const { selectedChat, leadsalesAI } = useChatContext();
  const {
    isLoading,
    error,
    generateSummary,
    checkEligibility,
    clearError,
  } = useConversationSummary();
  const { trackEvent } = useAnalytics();

  // Check eligibility when component mounts or conversationId changes
  useEffect(() => {
    if (selectedChat?.id) {
      checkEligibility(selectedChat.id);
    }
  }, [selectedChat?.id, checkEligibility]);

  // Función para generar el resumen de la conversación
  const handleGenerateSummary = async () => {
    if (!selectedChat?.id || isLoading) return;

    // Limpiar errores previos
    if (error) {
      clearError();
    }

    // Check for previous summary
    const previousSummary = leadsalesAI
      .filter((event) => isSummaryEvent(event))
      .sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      )[0];

    // Track click event
    trackEvent('front.chat.ai.summary.generate.click', {
      conversationId: selectedChat.id,
      hasPreviousSummary: !!previousSummary,
    });

    try {
      await generateSummary(selectedChat.id);
    } catch (err) {
      console.error('Error generating summary:', err);
    }
  };

  if (!selectedChat) return null;

  // Determinar el estado del botón - solo deshabilitado cuando está cargando
  const isDisabled = isLoading;

  return (
    <Tooltip message={props.tooltipMessage}>
      <Button
        color="ghost"
        onClick={handleGenerateSummary}
        size="xs"
        className="MessageBar__Button"
        disabled={isDisabled}
      >
        {isLoading ? (
          <Loading size="xs" />
        ) : (
          <DocumentTextIcon className="MessageBar__Icon" />
        )}
      </Button>
    </Tooltip>
  );
}